import ToposTop from "./ToposTop"

const ToposHead = () : JSX.Element => {
 
    return (
        <div className="topos-head-container w-100 flex-centered ">
            <div className="row w-100 h-100">
                <ToposTop />
                {/* <div className="col-xl-4 col-12 topos-head-right bg-secondary-super-light">
                    <ToposBreaks />
                    <ToposLinks />
                </div> */}
                <div className="col-md-2 bg-dark d-none">

                </div>
            </div>
        </div>
    )
} 

export default ToposHead